import config from "../../config";

const apiCoreEndpoint = config.apiCoreEndpoint;

export default apiCoreEndpoint;
